const actions = {
  SET_ALL_CONTRACTORS: "SET_ALL_CONTRACTORS",
  SET_ALL_CONTRACTOR_ACCOUNTS: "SET_ALL_CONTRACTOR_ACCOUNTS",
  setContractors: (data) => ({
    type: actions.SET_ALL_CONTRACTORS,
    payload: data,
  }),
  setContractorAccounts: (data) => ({
    type: actions.SET_ALL_CONTRACTOR_ACCOUNTS,
    payload: data,
  }),
};
export default actions;
